import type { components } from '@bookingdei/api-client/types';

type OfferCard = components['schemas']['OfferCard'];

// A bookable offer's "Book now" deep-links into the booking stepper carrying the offer
// (API-62): the server prices the discount into the hold quote, so the figure on the
// card and the figure at checkout cannot disagree. The stepper lives under the
// canonical short link /b/{slug}/book (DC54, DR-40).
export function stepperHref(offer: OfferCard): string {
  const params = new URLSearchParams({ offer: offer.id });
  if (offer.catalog_item_slug) params.set('service_slug', offer.catalog_item_slug);
  return `/b/${offer.business.slug}/book?${params.toString()}`;
}
